import { render, staticRenderFns } from "./Strategy.vue?vue&type=template&id=15ae3b3b&scoped=true"
import script from "./Strategy.vue?vue&type=script&lang=js"
export * from "./Strategy.vue?vue&type=script&lang=js"
import style0 from "./Strategy.vue?vue&type=style&index=0&id=15ae3b3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ae3b3b",
  null
  
)

export default component.exports